import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { AddressType } from 'types'
import { set as setNotification } from 'store/notification/actions'

import {
  remove,
  create,
  fetchOne,
  update,
} from 'UserApp/store/address/action'
import { selectOne } from 'UserApp/store/address/selector'
import AddressForm from 'UserApp/components/ManageAddress/Form'

class AddressFormContainer extends React.PureComponent {
  static propTypes = {
    create: PropTypes.func,
    fetchOne: PropTypes.func,
    id: PropTypes.string,
    onClose: PropTypes.func,
    remove: PropTypes.func, 
    update: PropTypes.func,
    values: PropTypes.shape(AddressType),
    setNotification: PropTypes.func,
  }

  state = {
    isConfirmingRemove: false,
    isLoading: !!this.props.id,
    isProcessing: false,
    customError: null,
  }

  componentDidMount() {
    if (this.props.id) {
      this.fetch()
    }
  }

  fetch = async () => {
    const { id, fetchOne } = this.props

    await fetchOne(id)

    this.setState({
      isLoading: false,
    })
  }

  handleSubmit = async (data) => {
    const { id, create, update, onClose, setNotification } = this.props
    // console.log(`CONTACT DATA :: `,data)

    const {address, apartmentSuite, city, zipCode, mobilePhone, emergencyAccess, country, state}= data

    if(!address || address.trim() === ''){
      return this.setState({
        customError: 'Address is required',
      });
    }
   
    if(!city || city.trim() === ''){
      return this.setState({
        customError: 'City is required',
      });
    }
    if(!mobilePhone || mobilePhone.trim() === ''){
      return this.setState({
        customError: 'Phone number is required',
      });
    }
    if(!zipCode || zipCode.trim() === ''){
      return this.setState({
        customError: 'Zip Code is required',
      });
    }

    if(!country || country.trim() === ''){
      return this.setState({
        customError: 'Country is required',
      });
    }
    if(!state || state.trim() === ''){
      return this.setState({
        customError: 'State is required',
      });
    }

    this.setState({
      isProcessing: true,
      customError: null,
    })

    try {
      if (id) {
        await update(id, data)

        setNotification(`Address updated`)
      } else {
        await create(data)
        setNotification(`Address added`)
      }
      onClose()
    } catch (error) {
      this.setState({
        isProcessing: false,
      })
      throw error
    }
  }

  handleRemove = () => this.setState({ isConfirmingRemove: true })

  handleCancelRemove = () => this.setState({ isConfirmingRemove: false })

  handleConfirmRemove = async () => {
    const { remove, onClose, id, setNotification } = this.props

    this.setState({
      isProcessing: true,
    })

    try {
      await remove(id)

      setNotification(`Address removed`)

      onClose()
    } catch (error) {
      this.setState({
        isProcessing: false,
      })
      throw error
    }
  }

  generateProps = () => {
    const { id } = this.props

    return {
      ...this.state,
      ...this.props,
      onSubmit: this.handleSubmit,
      isEditing: !!id,
      customError: this.state.customError,
    }
  }

  render() {
    const props = this.generateProps()

    return <AddressForm {...props} />
  }
}

export default connect(
  (state, ownProps) => {
    return {
      values: selectOne(state, ownProps) || {
        isEmergencyContact: true,
      },
    }
  },
  {
    create,
    update,
    remove,
    fetchOne,
    setNotification,
  },
)(AddressFormContainer)
